import "./style.css";
import { forwardRef, useImperativeHandle, useState } from "react";
import { requestGetTown } from "./../../../api/api.ramadan";

const RamadanTown = forwardRef((props, ref) => {
  const dialogId = "ramadan-town-dialog";
  const cardId = "ramadan-town-dialog-card";
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  function show(idState) {
    const dialog = document.getElementById(dialogId);
    dialog.showModal();
    setTimeout(() => {
      const container = document.getElementById(cardId);
      container.classList.add("show");
      setLoading(true);
      requestGetTown(idState).then((response) => {
        const result = response.result;
        setList(result);
        setLoading(false);
      });
    }, 300);
  }

  function onKeyDown(e) {
    if (e.key === "Escape") {
      hide();
    }
  }

  function onClickBackdrop(e) {
    const dialog = document.getElementById(dialogId);
    if (e === dialog) {
      hide();
    }
  }

  function hide() {
    const container = document.getElementById(cardId);
    container.classList.remove("show");
    setTimeout(() => {
      const dialog = document.getElementById(dialogId);
      dialog.close();
    }, 300);
  }

  function onClickItem(item) {
    hide();
    setTimeout(() => {
      if (props.onSelect) {
        props.onSelect(item.time_code, item.town_name);
      }
    }, 300);
  }

  const Items = () => {
    return list.map((item, i) => {
      return (
        <div
          id={"ramadan-town" + i}
          key={i}
          className="ramadan-town-item"
          onClick={() => onClickItem(item)}
        >
          <span>{item.time_code}</span>
          <span>{item.town_name}</span>
        </div>
      );
    });
  };

  const Loading = () => {
    return (
      <div className="ramadan-town-loading">
        <span>Memuat</span>
        <span>Sila tunggu...</span>
      </div>
    );
  };

  useImperativeHandle(ref, () => {
    return { show };
  });

  return (
    <dialog
      id={dialogId}
      className="ramadan-town-dialog"
      onKeyDown={(e) => onKeyDown(e)}
      onClick={(e) => onClickBackdrop(e.target)}
    >
      <div id={cardId} className="ramadan-town-content">
        {loading ? <Loading /> : <Items />}
      </div>
    </dialog>
  );
});

export default RamadanTown;
